import { Component, OnInit, ViewChild, ViewChildren } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { OrganizationService } from "src/app/Service/organization/organization.service";
import { IOrganizationViewModel } from "src/app/ViewModel/OrganizationModel";
import { EditMemberComponent } from "../dialogs/members-dialog/edit-member-dialog.component";
import { ExternalMemberService } from 'src/app/Service/member/external-member.service';
import { IMemebersViewModel } from 'src/app/ViewModel/MembersModel';
import { NotificationService } from 'src/app/Service/notification.service';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { GridComponent } from '@progress/kendo-angular-grid';
import { DynamickendoService, PageIcons } from 'src/app/CommonComponents/Dynamic-Kendo-UI/Service/Dynamic-kendo.service';
import { Router } from '@angular/router';
import { CommonService } from "src/app/Service/Common.service";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { ɵNullViewportScroller } from "@angular/common";
//import {PageIcons} from 'src/app/CommonComponents/Dynamic-Kendo-UI/Model';

@Component({
  selector: 'app-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.css']
})
export class MembersComponent implements OnInit {
  enableFilter = false;
  enableFullscreen = false;
  Pagename: PageIcons = PageIcons.Members;//"PageIcons.Members";
  businessGroupForm!: FormGroup;
  businessGroups: IOrganizationViewModel[] = [];
  grdSettings!: any[];
  public pageSize = [50, 100, 200, {
    text: 'All',
    value: 'all'
  }];
  /**Members list against the business group */
  public memberList: IMemebersViewModel[] = [];
  public _Url: string = "";
  groupId!: number;
  selectedGroup!: IOrganizationViewModel;
  public copymemberList: IMemebersViewModel[] = [];
  UnsubscribeArray: Subscription[] = [];
  selectedOption: string = 'Internal';
  is_Internal: boolean = true;
  @ViewChildren('grdMemberList') public gridSettingDetails!: GridComponent;

  constructor(private _dialog: MatDialog, private _orgService: OrganizationService, public _formBuilder: FormBuilder,
    private _extMemberService: ExternalMemberService, private _notificationService: NotificationService, private _DynamickendoService: DynamickendoService,
    private router: Router, private _commonService: CommonService,) {

  }

  ngOnInit() {
    this.groupId = this._commonService.getLoggedInUserGroupId();
    this.createBusinessGroupForm();
    this.getOrganizationList();
    this._Url = this.router.url;
    this.GetGridsettigs();
  }

  changeButtonToggle(event: any) {
    this.selectedOption = event.value;
    this.is_Internal = (event.value == 'Internal') ? true : false;
    this.getMembersList(this.selectedGroup);
  }

  createBusinessGroupForm() {
    this.businessGroupForm = this._formBuilder.group({
      businessGroup: new FormControl('')
    })
  }

  selectedOrganization(organization: IOrganizationViewModel) {
    this.selectedGroup = organization;
    this.getMembersList(organization);
  }

  /**
   * Get organization list
   */
  getOrganizationList() {
    let _getOrganizationList = this._orgService.getOrganizationList().subscribe((data: IOrganizationViewModel[]) => {
      this.businessGroups = data;
      this.selectedGroup = this.businessGroups.filter(h => {
        return h.group_Id == this.groupId
      })[0];
      this.businessGroupForm.get('businessGroup')?.setValue(this.selectedGroup);
      this.getMembersList(this.businessGroups.filter(h => {
        return h.group_Id == this.groupId
      })[0]);
    });
    this.UnsubscribeArray.push(_getOrganizationList);
  }

  /**
   * Get members list
   */
  getMembersList(group: IOrganizationViewModel) {
    let v: any = (typeof group === "object") ? group.group_Id : null
    let _getMembersList = this._extMemberService.GetMembersList({
      group_Id: v,
      member_Id: null
    }).subscribe((data: IMemebersViewModel[]) => {
      this.memberList = data.filter(i => i.is_Internal == this.is_Internal);
      this.copymemberList = this.memberList;
    });
    this.UnsubscribeArray.push(_getMembersList);
  }

  getFormattedMobileNo(mobile_No_Prefix: string, mobile_No: string | null) {
    return (mobile_No != '' && mobile_No != null) ? mobile_No_Prefix + ' ' + mobile_No : '';
  }

  addEditMember(member?: IMemebersViewModel | null) {
    if (member === undefined)
      member = null;
    const dialogRef = this._dialog.open(EditMemberComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '95%',
      minWidth: '95vw',
      data: {
        member: member,
        businessGroups: this.businessGroups,
        selectedGroup: this.businessGroupForm.get('businessGroup')?.value,
        memberList: this.copymemberList
      }
    });
    let _dialogRef = dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        let resMember: IMemebersViewModel = res.member;
        if (res.response && res.response.successCode == 200 && resMember) {
          let selectedGroup: IOrganizationViewModel = this.businessGroupForm.get('businessGroup')?.value;
          let filteredMember: IMemebersViewModel = this.memberList.filter(x => x.member_Id == resMember.member_Id)[0];
          if (filteredMember && selectedGroup && selectedGroup.group_Id == resMember.group_Id) {
            this.copyMemberAttributes(resMember, filteredMember);
          } else {
            let selectedGroup: IOrganizationViewModel = this.businessGroups.filter(x => x.group_Id == resMember.group_Id)[0];
            this.businessGroupForm.get('businessGroup')?.setValue(selectedGroup);
            this.memberList = [...this.memberList, ...[resMember]];
          }
          this._notificationService.showToast(res.response.successMessage, "Success");
          this.getMembersList(selectedGroup);
        } else if (res.response.successCode == 205) {
          this._notificationService.showToast(res.response.successMessage, "Warning");
        }
      }

    }, err => { });
    this.UnsubscribeArray.push(_dialogRef);
  }

  copyMemberAttributes(source: IMemebersViewModel, destination: IMemebersViewModel) {
    destination.member_Name = source.member_Name;
    destination.member_Short_Name = source.member_Short_Name;
    destination.is_Active = source.is_Active;
    destination.staff_PSNo = source.staff_PSNo;
    destination.designation = source.designation;
    destination.eMail_Id = source.eMail_Id;
    destination.ecc_Web_Login = source.ecc_Web_Login;
    destination.mobile_No = source.mobile_No;
    destination.group_Id = source.group_Id;
    destination.is_Internal = source.is_Internal;
    destination.mobile_No_Prefix = source.mobile_No_Prefix;
  }

  /**
   * Toggle filter
   */
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
   * Full screen
   */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }
  UnlockMember(dataitem: IMemebersViewModel) {
    this._notificationService.showPopup("Are you sure to unlock the user ? ", 'Confirm').then(data => {

      if (data == 'yes') {
        let selectedGroup: IOrganizationViewModel = this.businessGroupForm.get('businessGroup')?.value;
        let _UnlockUserDetails = this._extMemberService.UnlockUserDetails(dataitem.member_Id).subscribe((data: StandardOutputModel) => {
          if (data.successCode == 200) {
            let selectedGroup: IOrganizationViewModel = this.businessGroupForm.get('businessGroup')?.value;
            this.getMembersList(selectedGroup);
            this._notificationService.showToast(data.successMessage, "Success");

          }
        });
        this.UnsubscribeArray.push(_UnlockUserDetails);
      }
    });
  }
  unlock(lock_status: any): boolean {
    return lock_status.lock_status
  }
  gridSettings() {
    this._DynamickendoService.gridSettings(this.gridSettingDetails, this._Url);
  }
  GetGridsettigs() {
    let _GetGridSettings = this._DynamickendoService.GetGridSettings(this._Url).subscribe(res => {
      this.grdSettings = res;
    })
    this.UnsubscribeArray.push(_GetGridSettings);
  }

  Visible(Itemdata: any): boolean {
    return true;
  }
  ClickEvent(data: {
    Icondata: {
      Name: string; Isheader: any;
    }; Itemdata: IMemebersViewModel;
  }) {
    if (data.Icondata) {
      if (data.Icondata.Name == "Edit" && data.Itemdata)
        this.addEditMember(data.Itemdata);
      else if (data.Icondata.Name == "Unlock" && data.Itemdata)
        this.UnlockMember(data.Itemdata);
      else if (data.Icondata.Name == "Add Member" && data.Icondata.Isheader)
        this.addEditMember();

    }
  }

  myCallbackFunction = (Icondata: any, Itemdata: any): boolean => {
    if (Icondata.Name == "Edit")
      return true;
    else
      return this.unlock(Itemdata);
  }


  ngOnDestroy(): void {
    this.UnsubscribeArray.forEach(x => x.unsubscribe());
  }
}